module.exports = __webpack_public_path__ + "img/podovo_ohlajdane.ea388fd8.jpg";